import { Observable, of } from 'rxjs';
import { LogPublisher } from './log-publishers';
import { LogEntry, LogLevel } from './log.model';

export class LogConsole extends LogPublisher {
  log(record: LogEntry): Observable<boolean> {

    switch (record.level) {
      case LogLevel.Debug:
        console.debug(record.buildLogString());
        break;
      case LogLevel.Info:
        console.info(record.buildLogString());
        break;
      case LogLevel.Warn:
        console.warn(record.buildLogString());
        break;
      case LogLevel.Error:
        console.error(record.buildLogString());
        break;
      default:
        break;
    }
    // Log to the console

    return of(true);
  }

  clear(): Observable<boolean> {
   // console.clear();   disable to see full log 

    return of(true);
  }
}
